(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dps-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', function (event) {
    const detail = event.target;
    if (!(detail instanceof HTMLDetailsElement) || !detail.matches('.dps-menu') || !detail.open) return;
    detail.closest('.dps-navigation').querySelectorAll('.dps-menu[open]').forEach(function (other) { if (other !== detail) other.open = false; });
  }, true);
  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape' && event.code !== 'Escape') return;
    const detail = document.activeElement?.closest('.dps-menu[open]');
    if (!detail) return;
    detail.open = false;
    detail.querySelector('summary').focus();
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  const closeOutsideDesktopMenu = function (event) {
    document.querySelectorAll('.dps-navigation--desktop .dps-menu[open]').forEach(function (detail) {
      if (!detail.contains(event.target)) detail.open = false;
    });
  };
  document.addEventListener('click', closeOutsideDesktopMenu);
  document.addEventListener('focusin', closeOutsideDesktopMenu);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dps-reading-tools"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dps-reading-tools')) {
    customElements.define('dps-reading-tools', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
      }
      setup() {
        const content = document.getElementById(this.dataset.contentId);
        if (!content || this.dataset.ready) return;
        this.dataset.ready = 'true';
        const headings = [...content.querySelectorAll('h2,h3')].filter(heading => heading.textContent.trim());
        if (headings.length >= 4 && content.textContent.trim().length > 1200) {
          const details = document.createElement('details');
          const summary = document.createElement('summary');
          summary.textContent = this.dataset.navigationLabel;
          const navigation = document.createElement('nav');
          navigation.setAttribute('aria-label', this.dataset.navigationLabel);
          const list = document.createElement('ul');
          headings.forEach((heading, index) => {
            if (!heading.id) heading.id = `${this.dataset.contentId}-topic-${index + 1}`;
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.href = `#${encodeURIComponent(heading.id)}`;
            link.textContent = heading.textContent.trim();
            item.append(link);
            list.append(item);
          });
          navigation.append(list);
          details.append(summary, navigation);
          this.append(details);
        }
        this.observer = new ResizeObserver(entries => {
          for (const { target } of entries) {
            if (target.scrollWidth > target.clientWidth + 1) target.tabIndex = 0;
            else target.removeAttribute('tabindex');
          }
        });
        content.querySelectorAll('table').forEach(table => {
          if (table.parentElement.classList.contains('dps-reading-table')) return;
          const wrapper = document.createElement('div');
          wrapper.className = 'dps-reading-table';
          wrapper.setAttribute('role', 'region');
          wrapper.setAttribute('aria-label', table.caption?.textContent.trim() || this.dataset.tableLabel);
          table.before(wrapper);
          wrapper.append(table);
          this.observer.observe(wrapper);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
